// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__ePhRt","signature":"style_signature__1C3q1"};